import {
  DeepLinkRouteStrategyFactory,
  DEEPLINK_STRATEGY_TYPES,
} from './deepLinkRouteStrategyFactory';
import { registrationRoutes } from '../registrationRoutes';
import { appRoutes } from '../appRoutes';

const deriveDeeplinkRoute = (type, context) => {
  const strategy = new DeepLinkRouteStrategyFactory(type);
  return strategy.getRoute(context);
};

const getRouteDeeplinkPathSet = (routes) => new Set(
  Object.values(routes)
    .filter((route) => route?.deeplinkPath)
    .map((route) => route.deeplinkPath),
);

export const getAuthenticatedDeeplinkRoute = (context) => deriveDeeplinkRoute(DEEPLINK_STRATEGY_TYPES.AUTHENTICATED, {
  ...context,
  deeplinkPathSet: getRouteDeeplinkPathSet(appRoutes),
});

export const getUnauthenticatedDeeplinkRoute = (context) => deriveDeeplinkRoute(DEEPLINK_STRATEGY_TYPES.UNAUTHENTICATED, {
  ...context,
  deeplinkPathSet: getRouteDeeplinkPathSet(registrationRoutes),
});
